<template>
  <div class="firstpage alignfull" :class="{ showintro: showIntro }">
    <div class="container">
      <div class="intro">
        <img
          class="introimage"
          :src="imagePath + '/img/sjekkditttak.png'"
          role="presentation"
        />
        <h1 v-show="showIntro" class="introtitle text-hk-blue-light">
          {{ 'Sol ute, sol inne' }}
          <br />
          <span class="sub">Se hva du kan spare med solkraft fra oss</span>
        </h1>
      </div>

      <div class="search-sidepanel-wrapper">
        <div class="search-wrapper">
          <Search></Search>
        </div>
        <Sidepanel v-show="!showIntro && panel.kwtAar"></Sidepanel>
      </div>
      <div class="map-wrapper alignfull">
        <SunMap></SunMap>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store';

import Search from '../components/Search';
import SunMap from '../components/SunMap';
import Sidepanel from '../components/Sidepanel';

export default {
  name: 'StartPage',
  components: {
    Search,
    SunMap,
    Sidepanel,
  },
  computed: {
    imagePath() {
      return store.state.imagePath;
    },
    showIntro() {
      return store.state.showIntro;
    },
    panel() {
      return store.state.panelsVal;
    },
  },
};
</script>

<style scoped>
.firstpage {
  padding-top: 2rem;
}
.firstpage.showintro {
  background-image: url('./../assets/bg_paper.jpg');
  background-repeat: repeat;
  margin-top: -2em;
}

.firstpage.firstpage.showintro .notintro {
  display: none;
}

.firstpage.firstpage.showintro .map-wrapper {
  opacity: 0;
  visibility: hidden;
}

.firstpage.showintro .introimage {
  display: block;
}

.firstpage.showintro .container {
  max-width: 1000px;
  height: 100vh;
}

.firstpage:not(.showintro) .search-sidepanel-wrapper {
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: 2em;
  z-index: 1;
  width: 100%;
  height: 0;
}

.firstpage.showintro .search-wrapper {
  max-width: 750px;
  position: relative;
}

.firstpage:not(.showintro) .search-wrapper {
  width: 60%;
}

@media (max-width: 47.99em) {
  .firstpage:not(.showintro) .search-wrapper {
    width: 100%;
  }
}

.introimage {
  display: none;
  margin-bottom: -15em;
}

h1 {
  font-size: 3.5em;
}

h1.introtitle .sub {
  font-size: 0.7em;
  font-weight: normal;
  max-width: 650px;
  display: block;
}

@media (max-width: 47.99em) {
  h1 {
    font-size: 20px;
    width: 55%;
  }

  h1.introtitle .sub {
    font-size: 16px;
    font-weight: normal;
    max-width: 11rem;
    display: block;
  }

  .introimage {
    margin-bottom: -5.5em;
  }
}

.map-wrapper {
  z-index: -1;
  box-shadow: 0px 2px 15px 0px rgba(0, 149, 214, 0.3);
  height: 100%;
}
</style>
